var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoleTab(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user (22) 1",
    clipPath: "url(#clip0_9477_164089)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.49973 8.76297C5.20221 8.76297 3.33301 6.89392 3.33301 4.59641C3.33301 2.29889 5.20221 0.429688 7.49973 0.429688C9.79724 0.429688 11.6664 2.29889 11.6664 4.59641C11.6664 6.89392 9.79724 8.76297 7.49973 8.76297ZM7.49973 1.67969C5.89145 1.67969 4.58301 2.98798 4.58301 4.59641C4.58301 6.20468 5.89145 7.51297 7.49973 7.51297C9.108 7.51297 10.4164 6.20468 10.4164 4.59641C10.4164 2.98798 9.108 1.67969 7.49973 1.67969Z",
    fill: "#172B4D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.5417 19.5952H13.9583C13.1541 19.5952 12.5 18.941 12.5 18.1367V15.2202C12.5 14.4159 13.1541 13.7617 13.9583 13.7617H18.5417C19.3459 13.7617 20 14.4159 20 15.2202V18.1367C20 18.941 19.3459 19.5952 18.5417 19.5952ZM13.9583 15.0117C13.8434 15.0117 13.75 15.1051 13.75 15.2202V18.1367C13.75 18.2518 13.8434 18.3452 13.9583 18.3452H18.5417C18.6566 18.3452 18.75 18.2518 18.75 18.1367V15.2202C18.75 15.1051 18.6566 15.0117 18.5417 15.0117H13.9583Z",
    fill: "#172B4D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.7086 15.013H14.792C14.447 15.013 14.167 14.733 14.167 14.388V12.513C14.167 11.3647 15.1019 10.4297 16.2503 10.4297C17.3987 10.4297 18.3336 11.3647 18.3336 12.513V14.388C18.3336 14.733 18.0536 15.013 17.7086 15.013ZM15.417 13.763H17.0836V12.513C17.0836 12.0538 16.7094 11.6797 16.2503 11.6797C15.7911 11.6797 15.417 12.0538 15.417 12.513V13.763Z",
    fill: "#172B4D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.4167 17.9297H0.625C0.279999 17.9297 0 17.6497 0 17.3047V14.388C0 12.2055 1.77582 10.4297 3.95828 10.4297H11.25C11.9467 10.4297 12.6324 10.6139 13.2326 10.963C13.5309 11.1363 13.6316 11.5189 13.4584 11.8172C13.2851 12.1164 12.9025 12.2163 12.6033 12.043C12.1942 11.8056 11.7258 11.6797 11.25 11.6797H3.95828C2.46506 11.6797 1.25 12.8947 1.25 14.388V16.6797H10.4167C10.7617 16.6797 11.0417 16.9597 11.0417 17.3047C11.0417 17.6497 10.7617 17.9297 10.4167 17.9297Z",
    fill: "#172B4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9477_164089"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleTab);
export default __webpack_public_path__ + "static/media/roleTab.1f88899decb02b2f818c989df8ef671d.svg";
export { ForwardRef as ReactComponent };